import { Store } from '@/store/store.class'
import { LiveData, RouteLiveState } from '@/api/tripply/models'
import * as Tripply from '@/api/tripply'
import { store } from '..'

interface LiveState {
  routes: {[routeId: string]: LiveData | undefined };
  geolocationWatchId: number;
  subscription: () => void;
}

class LiveStore extends Store<LiveState> {
  constructor() {
    super({
      name: 'routeLive',
      cached: false,
      state: {
        routes: {},
        geolocationWatchId: 0,
        subscription: () => ({})
      }
    })
  }

  getLiveData(routeId: string) {
    return this.state.routes[routeId]
  }
  SET_LIVE_DATA(routeId: string, liveData: LiveData) {
    this.state.routes[routeId] = liveData
  }
  getLiveState(routeId: string): RouteLiveState | undefined {
    const liveData = this.getLiveData(routeId)
    if (liveData) {
      return Tripply.computeLiveState(routeId, {...liveData})
    }
    return
  }

  initialize(routeId: string) {    
    const unsubscribe = Tripply.onLiveUpdate(routeId, liveData => {  
      !liveData && store.route.SET_LIVE(routeId, false)
      this.SET_LIVE_DATA(routeId, liveData)
    })
    this.mutate(state => state.subscription = unsubscribe)
  }

  startTracking(routeId: string) {
    // const watchId = RouteLiveService.startTracking(routeId)
    // if (watchId) this.mutate(state => state.geolocationWatchId = watchId)
  }
    
  stopTracking() {
    // this.state.geolocationWatchId && RouteLiveService.stopTracking(this.state.geolocationWatchId)
    // this.mutate(state => state.geolocationWatchId = 0)
  }


  resetLive(routeId: string) {
    return Tripply.resetLive(routeId)
  }

  terminate(routeId: string) { 
    this.mutate(state => delete state.routes[routeId])
    this.state.subscription()
  }
    
}
export const liveStore = new LiveStore()